const normalizeText = (value?: string): string => {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

const ELBB_COLOR_BY_PERSPECTIVA: Record<string, string> = {
  cliente: 'elbb-cliente',
  clientes: 'elbb-cliente',
  financeiro: 'elbb-financeiro',
  financeira: 'elbb-financeiro',
  asg: 'elbb-asg',
  'transformacao digital e processos': 'elbb-transformacao-digital-processos',
  cultura: 'elbb-cultura',
  'pessoas e cultura': 'elbb-cultura'
};

export const getElbbCorCategoria = (perspectiva?: string): string | null => {
  const perspectivaNormalizada = normalizeText(perspectiva);
  if (!perspectivaNormalizada) return null;

  return ELBB_COLOR_BY_PERSPECTIVA[perspectivaNormalizada] || null;
};
